module.exports = __webpack_public_path__ + "img/ylands_generic_background_wireframing.e4b05855.png";